"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseConfigSchema = exports.AllBaseConfigSchemas = exports.OptionalStringConfigSchema = exports.StringConfigSchema = exports.OptionalPercentageConfigSchema = exports.PercentageConfigSchema = exports.OptionalIntegerConfigSchema = exports.IntegerConfigSchema = exports.OptionalFloatConfigSchema = exports.FloatConfigSchema = exports.OptionalDateTimeConfigSchema = exports.DateTimeConfigSchema = exports.OptionalDateConfigSchema = exports.DateConfigSchema = exports.OptionalCurrencyConfigSchema = exports.CurrencyConfigSchema = exports.OptionalBooleanConfigSchema = exports.BooleanConfigSchema = exports.makeOptionalType = exports.ValidTypesSchema = exports.isOptionalType = exports.OptionalTypes = exports.ValidTypes = exports.NumericTypes = void 0;
const Bank = __importStar(require("../../Bank"));
const Utils = __importStar(require("../../Utils"));
const zod_1 = require("zod");
// this compile time assert ensures that a function is exhaustive
// useful to use in your default case for switch statement.
const assertUnreachable = (x) => {
    throw new Error(`finleyAssertUnreachable: ${x}`);
};
/**
 * ============= DATA TAPE FIELD =============
 */
exports.NumericTypes = [
    'currency',
    'float',
    'integer',
    'percentage',
    'optionalCurrency',
    'optionalFloat',
    'optionalInteger',
    'optionalPercentage',
];
exports.ValidTypes = [
    'boolean',
    'date',
    'dateTime',
    'string',
    'optionalBoolean',
    'optionalDate',
    'optionalDateTime',
    'optionalString',
    ...exports.NumericTypes,
];
exports.OptionalTypes = [
    'optionalCurrency',
    'optionalFloat',
    'optionalInteger',
    'optionalPercentage',
    'optionalBoolean',
    'optionalDate',
    'optionalDateTime',
    'optionalString',
];
const isOptionalType = (type) => exports.OptionalTypes.includes(type);
exports.isOptionalType = isOptionalType;
exports.ValidTypesSchema = zod_1.z.enum(exports.ValidTypes);
const makeOptionalType = (type) => {
    if ((0, exports.isOptionalType)(type)) {
        return type;
    }
    switch (type) {
        case 'currency':
            return 'optionalCurrency';
        case 'float':
            return 'optionalFloat';
        case 'integer':
            return 'optionalInteger';
        case 'percentage':
            return 'optionalPercentage';
        case 'boolean':
            return 'optionalBoolean';
        case 'date':
            return 'optionalDate';
        case 'dateTime':
            return 'optionalDateTime';
        case 'string':
            return 'optionalString';
        default:
            return assertUnreachable(type);
    }
};
exports.makeOptionalType = makeOptionalType;
// Common config parts
const AbstractConfigSchema = zod_1.z.object({
    field: zod_1.z.string().describe('This field name in the tape'),
    columnToReadFrom: zod_1.z
        .string()
        .optional()
        .describe('Optional source column override'),
    description: zod_1.z.string().optional().describe('Customer-facing description'),
});
const RequiredFieldConfigSchema = AbstractConfigSchema.extend({
    defaultTo: zod_1.z
        .string()
        .optional()
        .describe('Default value if the field is null (required fields only)'),
});
const OptionalFieldConfigSchema = AbstractConfigSchema.extend({
    externalNullValues: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .describe('Values to treat as null (optional fields only)'),
});
// Boolean
exports.BooleanConfigSchema = RequiredFieldConfigSchema.extend({
    externalBooleanTrue: zod_1.z.string().describe('CSV string mapping to true'),
    type: zod_1.z.literal('boolean'),
});
exports.OptionalBooleanConfigSchema = OptionalFieldConfigSchema.extend({
    externalBooleanTrue: zod_1.z.string().describe('CSV string mapping to true'),
    type: zod_1.z.literal('optionalBoolean'),
});
// Currency
exports.CurrencyConfigSchema = RequiredFieldConfigSchema.extend({
    currencyCode: Bank.CurrencyCodeSchema.describe('Currency code'),
    type: zod_1.z.literal('currency'),
});
exports.OptionalCurrencyConfigSchema = OptionalFieldConfigSchema.extend({
    currencyCode: Bank.CurrencyCodeSchema.describe('Currency code'),
    type: zod_1.z.literal('optionalCurrency'),
});
// Date
exports.DateConfigSchema = RequiredFieldConfigSchema.extend({
    externalDateFormat: zod_1.z.string().describe('Date format string'),
    expectExcelFormatForSanitize: zod_1.z
        .boolean()
        .optional()
        .describe('Expect Excel serial date format for sanitization'),
    type: zod_1.z.literal('date'),
});
exports.OptionalDateConfigSchema = OptionalFieldConfigSchema.extend({
    externalDateFormat: zod_1.z.string().describe('Date format string'),
    expectExcelFormatForSanitize: zod_1.z
        .boolean()
        .optional()
        .describe('Expect Excel serial date format for sanitization'),
    type: zod_1.z.literal('optionalDate'),
});
// DateTime
exports.DateTimeConfigSchema = RequiredFieldConfigSchema.extend({
    externalDateTimeFormat: zod_1.z.string().describe('DateTime format string'),
    defaultTz: zod_1.z.nativeEnum(Utils.DateTimeZones).describe('Default timezone'),
    type: zod_1.z.literal('dateTime'),
});
exports.OptionalDateTimeConfigSchema = OptionalFieldConfigSchema.extend({
    externalDateTimeFormat: zod_1.z.string().describe('DateTime format string'),
    defaultTz: zod_1.z.nativeEnum(Utils.DateTimeZones).describe('Default timezone'),
    type: zod_1.z.literal('optionalDateTime'),
});
// Float, Integer, Percentage
exports.FloatConfigSchema = RequiredFieldConfigSchema.extend({
    type: zod_1.z.literal('float'),
});
exports.OptionalFloatConfigSchema = OptionalFieldConfigSchema.extend({
    type: zod_1.z.literal('optionalFloat'),
});
exports.IntegerConfigSchema = RequiredFieldConfigSchema.extend({
    type: zod_1.z.literal('integer'),
});
exports.OptionalIntegerConfigSchema = OptionalFieldConfigSchema.extend({
    type: zod_1.z.literal('optionalInteger'),
});
exports.PercentageConfigSchema = RequiredFieldConfigSchema.extend({
    type: zod_1.z.literal('percentage'),
});
exports.OptionalPercentageConfigSchema = OptionalFieldConfigSchema.extend({
    type: zod_1.z.literal('optionalPercentage'),
});
// String
exports.StringConfigSchema = RequiredFieldConfigSchema.extend({
    type: zod_1.z.literal('string'),
});
exports.OptionalStringConfigSchema = OptionalFieldConfigSchema.extend({
    type: zod_1.z.literal('optionalString'),
});
// we need to expose these schemas for
// extending these configs individually outside this file
exports.AllBaseConfigSchemas = [
    exports.BooleanConfigSchema,
    exports.OptionalBooleanConfigSchema,
    exports.CurrencyConfigSchema,
    exports.OptionalCurrencyConfigSchema,
    exports.DateConfigSchema,
    exports.OptionalDateConfigSchema,
    exports.DateTimeConfigSchema,
    exports.OptionalDateTimeConfigSchema,
    exports.FloatConfigSchema,
    exports.OptionalFloatConfigSchema,
    exports.IntegerConfigSchema,
    exports.OptionalIntegerConfigSchema,
    exports.PercentageConfigSchema,
    exports.OptionalPercentageConfigSchema,
    exports.StringConfigSchema,
    exports.OptionalStringConfigSchema,
];
// Discriminated union of all configs
exports.BaseConfigSchema = zod_1.z
    .discriminatedUnion('type', exports.AllBaseConfigSchemas)
    .describe('Union of all DataTapeField config types');
//# sourceMappingURL=DataTapeField.js.map